module.exports = __webpack_public_path__ + "static/media/success.ecd6ea3d.gif";